import { Table, ScrollArea, LoadingOverlay, Pagination, Flex, Title } from '@mantine/core';
import { useWindowScroll } from '@mantine/hooks';

type Props = {
  titles: string[];
  rows: React.ReactNode[];
  tableTitle?: string;
  isLoading?: boolean;
  isPaginated?: boolean;
  itemsCount?: number;
  pageSize?: number;
  currentPage?: number;
  onPageChange?: (page: number) => void;
  children?: React.ReactElement;
};

export const CustomTable = (props: Props) => {
  const {
    titles,
    rows,
    tableTitle,
    isLoading,
    isPaginated = true,
    itemsCount = 1,
    pageSize = 30,
    currentPage,
    onPageChange,
  } = props;

  const pageCount = Math.ceil(itemsCount / pageSize);

  const [, scrollTo] = useWindowScroll();
  const handlePageChange = (page: number) => {
    onPageChange?.(page);
    scrollTo({ y: 0 });
  };

  return (
    <>
      {tableTitle && (
        <Title order={5}>{tableTitle}</Title>
      )}

      <ScrollArea type="scroll" offsetScrollbars style={{ position: 'relative' }}>
        <LoadingOverlay
          visible={isLoading}
          overlayProps={{ blur: 2 }}
        />

        <Table
          highlightOnHover
          striped
          captionSide="bottom"
          style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1 }}
        >
          <Table.Thead>
            <Table.Tr>
              {titles.map((title) => (
                <Table.Th key={title}>{title}</Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>

          {rows.length > 0
            ? (
              <Table.Tbody>{rows}</Table.Tbody>
            )
            : (
              <Table.Caption>Нет данных</Table.Caption>
            )
          }

        </Table>
      </ScrollArea>

      {isPaginated && rows.length > 0 && (
        <Flex justify="center" mt="md" mb="xl">
          <Pagination
            value={currentPage}
            onChange={(page: number) => handlePageChange(page)}
            total={pageCount}
          />
        </Flex>
      )}
    </>
  );
};
